import React from 'react';
import AnswerManagementComponent from '../../../components/admin/coffee-chat/AnswerManagementComponent';

const AnswerManagement: React.FC = () => {
  return <AnswerManagementComponent />;
};

export default AnswerManagement;
